import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, FormControl, IconButton, InputLabel, Select, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import useTranslate from '../../../../../../../localization/helpers';
var TranslateSelection = function (_a) {
    var selectedContent = _a.selectedContent, dropdownOptions = _a.dropdownOptions, handleLanguageSelect = _a.handleLanguageSelect, translateText = _a.translateText;
    var theme = useTheme();
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isIpad = useMediaQuery('(min-width: 768px) and (max-width: 1024px)');
    var translate = useTranslate().translate;
    var handleLanguageTranslation = function (event) {
        var value = event.target.value;
        var langcode = handleLanguageSelect(value);
        translateText(selectedContent, langcode, event.target);
    };
    var formatSelectedText = function () {
        var selection = window.getSelection();
        if (!selection || selection.rangeCount === 0)
            return '';
        var selectedText = '';
        for (var i = 0; i < selection.rangeCount; i++) {
            var range = selection.getRangeAt(i);
            selectedText += range.cloneContents().textContent + ' ';
        }
        selectedText = selectedText
            .replace(/(\.)(\s*)(\d+\.)/g, '$1\n$3')
            .replace(/(\.)(\s*)([a-zA-Z]\.)/g, '$1\n$3')
            .replace(/(\.)(\s*)([IVXLCDM]+\.)/g, '$1\n$3')
            .replace(/(\.)(\s*)(-)/g, '$1\n$3')
            .replace(/(\.)(\s*)(•)/g, '$1\n$3')
            .replace(/\n+/g, '\n');
        return selectedText.trim();
    };
    var handleTextCopying = function (event) {
        var textToCopy = formatSelectedText() || selectedContent;
        navigator.clipboard.writeText(textToCopy);
        var parentElement = event.currentTarget.closest('.translate-component');
        if (parentElement) {
            parentElement.style.visibility = 'hidden';
        }
    };
    return (_jsxs(FormControl, { fullWidth: true, sx: { mb: isXs || isIpad ? 8 : 0 }, className: 'translate-component', children: [_jsx(InputLabel, { shrink: true, sx: {
                    color: 'white',
                    '&.MuiInputLabel-shrink': {
                        color: 'white',
                        mt: 1.2,
                        ml: 4.5
                    },
                    '&.Mui-focused': { color: 'white !important', mt: 1.2, ml: 4.5 }
                }, children: translate('common.translate') }), _jsxs(Box, { display: 'flex', alignItems: 'center', sx: {
                    borderRadius: '6px',
                    bgcolor: 'black'
                }, children: [_jsx(Box, { borderRight: '1px solid white', children: _jsx(Tooltip, { title: 'Copy Text', children: _jsx(IconButton, { sx: {
                                    color: 'white',
                                    bgcolor: 'black',
                                    borderRadius: 0,
                                    '&:hover': {
                                        bgcolor: '#333'
                                    }
                                }, onClick: handleTextCopying, children: _jsx(ContentCopyIcon, {}) }) }) }), _jsxs(Select, { sx: {
                            flex: 1,
                            minWidth: '200px',
                            color: 'white',
                            '& .MuiNativeSelect-icon': {
                                color: 'white',
                                display: isXs || isIpad ? 'none' : 'flex'
                            },
                            '& option': {
                                color: 'black',
                                backgroundColor: 'white'
                            }
                        }, native: true, onChange: handleLanguageTranslation, children: [_jsx("option", { value: '', children: "None" }), dropdownOptions.map(function (option) { return (_jsx("option", { value: option, children: option }, option)); })] })] })] }));
};
export default TranslateSelection;
